module.exports = __webpack_public_path__ + "img/logo-uv-negro.71c55064.svg";